import { render, staticRenderFns } from "./LessonActionGroups.vue?vue&type=template&id=47032f4d&scoped=true&"
import script from "./LessonActionGroups.vue?vue&type=script&lang=js&"
export * from "./LessonActionGroups.vue?vue&type=script&lang=js&"
import style0 from "./LessonActionGroups.vue?vue&type=style&index=0&id=47032f4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47032f4d",
  null
  
)

export default component.exports